import React from "react";
import { bindActionCreators, Dispatch } from "redux";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Router from "react-router-dom";
import { connect } from "react-redux";
import { RootState } from "redux/store";
import { getUser } from "redux/selector";
import { enhancedBioEnabled } from "shared/env";
import { Agent } from "model/agent";
import { Info } from "./info";
import { styles } from "./styles";
import { AgentSettingsTab } from "./tab-agent-settings";
import { BioTab } from "./tab-bio";
import { LeadCaptureTab } from "./tab-email-header";
import { AppCard } from "component/shared/app-card";

interface Props extends OwnProps, 
	Router.RouteComponentProps<RouteParams>,
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	WithStyles<typeof styles> {
}

interface OwnProps {
	agent: Agent;
}

interface State {
	tab: number;
}

interface RouteParams {
	id: string;
}

const mapStateToProps = (state: RootState, ownProps: Router.RouteComponentProps<RouteParams>) => {
	const user = getUser(state);
	const isEnhancedBioEnabled = enhancedBioEnabled && state.brokerSettings.isEnhancedBioEnabled;
	return {
		user,
		isEnhancedBioEnabled,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

class Component extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			tab: 0,
		}
	}

	public render() {
		const { user, agent, classes = {}, isEnhancedBioEnabled } = this.props;
		const { tab } = this.state;

		if (!agent) {
			return <>Error</>;
		}
		return (
			<Mui.Grid container spacing={2}>
				<Mui.Grid item xl={3} lg={4} sm={6} xs={12}>
					<AppCard>
						<Mui.CardHeader
							title="Profile"
							classes={{
								root: classes.root,
								title: classes.title,
							}}
						/>
						<Mui.CardContent style={{padding: 25, paddingTop: 10}}>
							<Info agent={agent} user={user} />
						</Mui.CardContent>
					</AppCard>
				</Mui.Grid>
				<Mui.Grid item xl={9} lg={8} sm={6}>
					{(user.admin || user.agentId === agent.id) && (
						<Mui.Grid container direction="column" spacing={2} style={{marginLeft: 5}}>
							<Mui.Grid item>
								<Mui.Tabs
									value={tab}
									onChange={(_, tabIndex) => this.setState({tab: tabIndex})}
									>
									<Mui.Tab label="Settings" />
									{((user.ownsLeads && agent.allowModifyBio) || user.admin) && (
										<Mui.Tab label="Public Bio" />
									)}
									{((user.ownsLeads && agent.allowModifySubscribers) || user.admin) && (
										<Mui.Tab label="Email Header" />
									)}
								</Mui.Tabs>
							</Mui.Grid>
							<Mui.Grid item>
								<Mui.Grid item lg={8} sm={6}>
									{tab === 0 && (
										<AgentSettingsTab agent={agent} />
									)}
									{tab === 1 && ((user.ownsLeads && agent.allowModifyBio) || user.admin) && (
										<BioTab agent={agent} isEnhancedBioEnabled={isEnhancedBioEnabled} />
									)}
									{tab === 1 && !((user.ownsLeads && agent.allowModifyBio) || user.admin) && (
										<LeadCaptureTab agent={agent} />
									)}
									{tab === 2 && (
										<LeadCaptureTab agent={agent} />
									)}
								</Mui.Grid>
							</Mui.Grid>
						</Mui.Grid>
					)}
				</Mui.Grid>
			</Mui.Grid>
		);
	}

}

export const Profile = withStyles(
	Router.withRouter(connect(mapStateToProps, mapDispatchToProps)(Component)),
	styles
);